import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNotificationRepository } from "@/infrastructure/di";
import type { NotificationFilters, NotificationListResponse } from "@/domain";
import { queryKeys } from "../queryKeys";

/** Notifications are dynamic data — keep stale time short for near-realtime updates */
const NOTIFICATION_STALE_TIME = 30 * 1000; // 30 seconds
const PAGE_SIZE = 10;

export const useNotifications = (filters?: NotificationFilters, enabled = true) => {
  return useInfiniteQuery<NotificationListResponse>({
    queryKey: queryKeys.notifications.list(filters),
    queryFn: ({ pageParam }) =>
      getNotificationRepository().getNotifications({
        ...filters,
        limit: PAGE_SIZE,
        offset: pageParam as number,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const nextOffset = lastPage.offset + lastPage.notifications.length;
      return nextOffset < lastPage.total_count ? nextOffset : undefined;
    },
    staleTime: NOTIFICATION_STALE_TIME,
    enabled,
  });
};

export const useNotificationStats = (enabled = true) => {
  return useQuery({
    queryKey: queryKeys.notifications.stats(),
    queryFn: () => getNotificationRepository().getNotificationStats(),
    staleTime: NOTIFICATION_STALE_TIME,
    enabled,
  });
};
